module.exports = __webpack_public_path__ + "static/img/agent3.db737490.png";